import store from '../store';
/**
 * 校验用户是否拥有目标权限
 * @param {String} permissionCode 权限编码（如 "user:add"）
 * @returns {Boolean} 是否拥有该权限
 */
export function hasPermission(permissionCode) {
  const { userInfo = {} } = store.state.user.userInfo;
  const permissions = store.state.user.perms || [];
  return permissions.includes(permissionCode);
}